function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

const ALL_COUNTRIES = [
  // Asia
  { id: 1, name: 'India', continent: 'Asia', hint: 'This country has the Taj Mahal, loves cricket, and is famous for spicy curry.' },
  { id: 2, name: 'China', continent: 'Asia', hint: 'This country built the Great Wall, has pandas, and invented noodles.' },
  { id: 3, name: 'Japan', continent: 'Asia', hint: 'This country has Mount Fuji, sushi, and beautiful cherry blossoms.' },
  { id: 4, name: 'Saudi Arabia', continent: 'Asia', hint: 'This desert country is famous for oil and has the holy city of Mecca.' },
  { id: 5, name: 'Thailand', continent: 'Asia', hint: 'This country is known as the Land of Smiles and has amazing temples.' },
  { id: 6, name: 'South Korea', continent: 'Asia', hint: 'This country is famous for K-pop music, kimchi, and Samsung phones.' },

  // Europe
  { id: 7, name: 'France', continent: 'Europe', hint: 'This country has the Eiffel Tower, croissants, and the Mona Lisa painting.' },
  { id: 8, name: 'Italy', continent: 'Europe', hint: 'This country is famous for pizza, pasta, and the Colosseum in Rome.' },
  { id: 9, name: 'United Kingdom', continent: 'Europe', hint: 'This country has Big Ben, the King, and people love drinking tea.' },
  { id: 10, name: 'Spain', continent: 'Europe', hint: 'This country is famous for flamenco dancing, bulls, and tomato festivals.' },
  { id: 11, name: 'Germany', continent: 'Europe', hint: 'This country makes great cars like BMW, loves sausages, and has Oktoberfest.' },
  { id: 12, name: 'Greece', continent: 'Europe', hint: 'This country started the Olympic Games and has beautiful white and blue islands.' },

  // North America
  { id: 13, name: 'United States', continent: 'North America', hint: 'This country has the Statue of Liberty, Hollywood, and NASA.' },
  { id: 14, name: 'Canada', continent: 'North America', hint: 'This country has a maple leaf on its flag, loves ice hockey, and has lots of snow.' },
  { id: 15, name: 'Mexico', continent: 'North America', hint: 'This country is famous for tacos, ancient pyramids, and the Day of the Dead festival.' },

  // South America
  { id: 16, name: 'Brazil', continent: 'South America', hint: 'This country loves football, has the Amazon rainforest, and a famous carnival.' },
  { id: 17, name: 'Argentina', continent: 'South America', hint: 'This country is famous for tango dancing and the footballer Lionel Messi.' },
  { id: 18, name: 'Peru', continent: 'South America', hint: 'This country has the ancient city of Machu Picchu high in the mountains.' },

  // Africa
  { id: 19, name: 'Egypt', continent: 'Africa', hint: 'This country has the Great Pyramids, the Sphinx, and the River Nile.' },
  { id: 20, name: 'South Africa', continent: 'Africa', hint: 'This country is famous for safaris, Nelson Mandela, and the rainbow nation.' },
  { id: 21, name: 'Kenya', continent: 'Africa', hint: 'This country is famous for safaris, marathon runners, and Mount Kilimanjaro is nearby.' },
  { id: 22, name: 'Nigeria', continent: 'Africa', hint: 'This is the most populated country in Africa and is famous for Nollywood movies.' },

  // Oceania
  { id: 23, name: 'Australia', continent: 'Oceania', hint: 'This country has kangaroos, koalas, and the Sydney Opera House.' },
  { id: 24, name: 'New Zealand', continent: 'Oceania', hint: 'This country has kiwi birds, the All Blacks rugby team, and the Lord of the Rings was filmed here.' },
];

function getDistractors(correct, all, count = 3) {
  const others = all.filter((c) => c.id !== correct.id);
  return shuffle(others).slice(0, count);
}

export function getCountryQuestions(count = 15) {
  const selected = shuffle(ALL_COUNTRIES).slice(0, Math.min(count, ALL_COUNTRIES.length));

  return selected.map((country) => {
    const distractors = getDistractors(country, ALL_COUNTRIES, 3);
    const options = shuffle([country, ...distractors]);
    const correctIndex = options.findIndex((o) => o.id === country.id);

    return {
      id: country.id,
      hint: country.hint,
      continent: country.continent,
      answer: country.name,
      options: options.map((o) => o.name),
      correctIndex,
    };
  });
}
